import i18n from "i18next";

export const songNum = (sn?: number): string => {
  const snStr = sn ? sn.toString() : "";
  return i18n.t("schedules.song %d", { "0": snStr });
};
